import React from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { INavbarItem } from '@models/interfaces/navigation.interface';
import TopNavbarItem from '@components/navigation/TopNavbarItem';

export interface TopNavbarProps {
  items: INavbarItem[];
  onClickNavigation: (key: string) => void;
}

const TopNavbar = (props: TopNavbarProps) => {
  const location = useLocation();

  function handleClick(e: React.FormEvent, item: INavbarItem) {
    if (matchPath('/:subjectId/099-03/:delayedStartDate', location.pathname))
      return false; // prevent navigation when on showing error 099-03 page

    props.onClickNavigation(item.key);
    e.preventDefault();
  }

  return (
    <div className={'flex'}>
      {props.items
        .filter(item => item.showInTopNavbar && !item.hide)
        .map(item => {
          return (
            <div
              onClick={event => handleClick(event, item)}
              key={item.key}
              className={'flex-initial mr-8 last:mr-0'}
            >
              <TopNavbarItem {...item} />
            </div>
          );
        })}
    </div>
  );
};

export default TopNavbar;
